module.exports = __webpack_public_path__ + "img/quality-01-portrait.fd8b0b54.jpg";